import React, { useEffect, useState } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomDropDown from '../../shared/CustomDropDown';
import { orderByList } from '../constants';
import { orderLabel } from '../utils';

const useStyles = makeStyles({
  title: {
    fontFamily: 'Lato',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22.4px',
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  selectField: {
    fontFamily: 'Lato',
    width: '495px',
    height: '44px',
    padding: '12px 16px 12px 16px',
    marginTop: '8px',
    background: 'white',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
  },
});

const RankingLogic = ({ handleChange, metaColumns, data }) => {
  const classes = useStyles();
  const [columnNames, setColumnNames] = useState([]);
  useEffect(() => {
    const output = metaColumns?.map((item) => ({ id: item?.columnName, name: item.columnName }));
    setColumnNames(output);
  }, [metaColumns]);
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography className={classes.title}>Ranking Logic</Typography>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <CustomPopupText text="Select Column" required />
          </Grid>
          <Grid item xs={6}>
            <CustomPopupText text="Sort By" required />
          </Grid>
        </Grid>

        <Grid container item spacing={2} className={classes.rowContainer}>
          <Grid item xs={6}>
            <CustomDropDown
              list={columnNames}
              height="44px"
              width="482px"
              marginBottom="20px"
              name="columnName"
              handleChange={handleChange}
              value={data?.ranking?.columnName}
            />
          </Grid>
          <Grid item xs={6} container justifyContent="center">
            <CustomDropDown
              list={orderByList}
              height="44px"
              width="482px"
              marginBottom="20px"
              name="orderBy"
              handleChange={handleChange}
              value={orderLabel(data?.ranking?.orderBy)}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RankingLogic;
